module.exports = __webpack_public_path__ + "static/media/291790.0133d3af.png";